export default "__VITE_PUBLIC_ASSET__e5092f44__"